import { CALL_API } from 'redux-api-middleware';
import { commonHeaders } from 'helpers/api';
import { getConfig } from 'modules/config';
import { reduceReducers, createReducer } from 'helpers/redux';

export const namespace = 'flows';

export const LIST = 'vtn/flows/LIST';
export const LIST_SUCCESS = 'vtn/flows/LIST_SUCCESS';
export const LIST_FAILURE = 'vtn/flows/LIST_FAILURE';

export const FLOW = 'vtn/flows/FLOW';
export const FLOW_SUCCESS = 'vtn/flows/FLOW_SUCCESS';
export const FLOW_FAILURE = 'vtn/flows/FLOW_FAILURE';

export const FLOW_TO_NULL = 'vtn/flows/FLOW_TO_NULL';

export const SET_SELECTED_FLOW = 'vtn/flows/SET_SELECTED_FLOW';
export const SELECTED_FLOW_TO_NULL = 'vtn/flows/SELECTED_FLOW_TO_NULL';

const defaultState = {
  flows: [],
  flowById: null,
  isFetchingFlows: false,
  selectedFlow: {}
};

const reducer = reduceReducers(
  createReducer(defaultState, {
    [LIST](state, action) {
      return {
        ...state,
        isFetchingFlows: true
      };
    },
    [LIST_SUCCESS](state, action) {
      return {
        ...state,
        isFetchingFlows: false,
        flows: action.payload.data.flows.records
      };
    },
    [LIST_FAILURE](state, action) {
      return {
        ...state,
        isFetchingFlows: false,
        flows: []
      };
    },
    [FLOW](state, action) {
      return {
        ...state,
        isFetchingFlow: true
      };
    },
    [FLOW_SUCCESS](state, action) {
      return {
        ...state,
        isFetchingFlow: false,
        flowById: action.payload.data.flows.records[0]
      };
    },
    [FLOW_FAILURE](state, action) {
      return {
        ...state,
        isFetchingFlow: false,
        flowById: null
      };
    },
    [FLOW_TO_NULL](state, action) {
      return {
        ...state,
        flowById: null
      };
    },
    [SET_SELECTED_FLOW](state, action) {
      return {
        ...state,
        selectedFlow: state.flowById,
        flowById: null
      };
    },
    [SELECTED_FLOW_TO_NULL](state, action) {
      return {
        ...state,
        selectedFlow: null
      };
    }
  })
);

export default reducer;

function local(state) {
  return state[namespace];
}

export function isFetchingFlows(state) {
  return local(state).isFetchingFlows;
}

export function getFlowsList(state) {
  return local(state).flows;
}

export function getFlowById(state) {
  return local(state).flowById;
}

export function getSelectedFlows(state) {
  return local(state).selectedFlow;
}

export function nullifyFlow() {
  return {
    type: FLOW_TO_NULL
  };
}

export function selectFlow() {
  return {
    type: SET_SELECTED_FLOW
  };
}

export function nullifySelectedFlow() {
  return {
    type: SELECTED_FLOW_TO_NULL
  };
}

export const listFlows = values => {
  const query = `query {
    flows {
      records {
        id
        title
        subtitle
        description
        image
      }
    }
  }`;

  return {
    [CALL_API]: {
      types: [LIST, LIST_SUCCESS, LIST_FAILURE],
      endpoint: state => getConfig(state).services.graphqlUri,
      method: 'POST',
      body: JSON.stringify({
        query
      }),
      headers: commonHeaders
    }
  };
};

export const fetchFlowById = id => {
  const query = `query {
    flows(id: ${id}) {
      records {
        id
        title
        subtitle
        description
        categories
        flow
        package
        image
        screenshots
        tags
        author
        public
        learnmorelink
        logo
      }
    }
  }`;

  return {
    [CALL_API]: {
      types: [FLOW, FLOW_SUCCESS, FLOW_FAILURE],
      endpoint: state => getConfig(state).services.graphqlUri,
      method: 'POST',
      body: JSON.stringify({
        query
      }),
      headers: commonHeaders
    }
  };
};



// WEBPACK FOOTER //
// ./src/client/modules/flows/index.js